import { Component, OnInit } from '@angular/core';
import {CommonService} from '../../../../services/common.service';
import {ToastMessagesService} from '../../../../services/toast-messages.service';
import {ConfirmDialogComponent} from '../../../shared/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {AssignLevelsToActivityComponent} from '../assign-levels-to-activity/assign-levels-to-activity.component';
import {Activity, Level} from '../../../../models/applicationFeature';


@Component({
  selector: 'app-activities-dialog',
  templateUrl: './activities-dialog.component.html',
  styleUrls: ['./activities-dialog.component.scss']
})
export class ActivitiesDialogComponent implements OnInit {
  pageTitle: any;
  newActivity: any;
  loadingActivities: boolean;
  levels: Level[];
  activities: Activity[];

  constructor(public commonService: CommonService,
              public dialog: MatDialog,
              public toastMessagesService: ToastMessagesService) {
    this.loadingActivities = false;
    this.newActivity = '';
    this.levels = [];
  }

  async ngOnInit() {
    await this.initActivities();
    await this.initLevels();
  }

  async initActivities() {
    this.loadingActivities = true;
    try {
      const activitiesRequest = await this.commonService.getList('activities');
      for (const activity of activitiesRequest.object) {
        const levelsRequest = await this.commonService.getList(`activities/assign?id=${activity.id}`);
        activity.assignedLevels = levelsRequest.object;
      }
      this.activities = activitiesRequest.object;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loadingActivities = false;
    }
  }

  async initLevels() {
    try {
      const levelsRequest = await this.commonService.getList('activities/levels');
      this.levels = levelsRequest.object;
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
    }
  }

  async insertActivity() {
    const value = this.newActivity;
    if (value.trim() === '') {
      this.toastMessagesService.toastErrorMessage('Θα πρέπει να συμπληρώσετε την περιγραφή της δραστηριότητας');
      return;
    }

    try {
      await this.commonService.insertItem(`activities`, {description: value});
      this.toastMessagesService.toastMessages('Η εισαγωγή ολοκληρώθηκε με επιτυχία');
      await this.initActivities();
      this.clearNewActivity();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }



  confirmDeletion(activity: Activity) {
    const deleteDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: 'Διαγραφή Δραστηριότητας',
        message: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την δραστηριότητα. Προσοχή θα διαγραφούν και όλες οι αναθέσεις που έχουν γίνει?',
        icon: 'delete'
      }
    });

    deleteDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.deleteActivity(activity);
      }
    });
  }

  async deleteActivity(activity: Activity) {
    try {
      await this.commonService.deleteItem(`activities?id=${activity.id}`);
      this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
      await this.initActivities();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  clearNewActivity() {
    this.newActivity = '';
  }

  assignLevelsToActivity(activity: Activity) {
    const assignmentDialog = this.dialog.open(AssignLevelsToActivityComponent, {
      data: {
        activity,
        levels: this.levels
      }
    });

    assignmentDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          activity.assignedLevels = result;
          const model = {
            activityId: activity.id,
            levels: result
          };
          await this.commonService.insertItem('activities/assign', model);
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }
}
